import { combineReducers } from 'redux-immutable';

import userReducer from './userReducer';
import projectReducer from './projectReducer';
import serviceReducer from './serviceReducer';
import clientsReducer from './clientReducer';
import credentialReducer from './credentialReducer';
import rbacReducer from './rbacReducer';
import taskReducer from './taskReducer';
import legalEntitiesReducer from './legalEntitiesReducer';
import articlesReducer from './articleReducer';
import eventsReducer from './eventReducer';
import commentReducer from './commentReducer';
import activityLogReducer from './activityLogReducer';
import salaryHistoryReducer from './salaryHistoryReducer';
import companyReducer from './companyReducer';
import fileReducer from './fileReducer';
import metaInformationReducer from './metaInformationReducer';
import scheduleReducer from './scheduleReducer';
import workspaceReducer from './workspaceReducer';

const entitiesReducer = combineReducers({
  file: fileReducer,
  activityLog: activityLogReducer,
  article: articlesReducer,
  client: clientsReducer,
  comment: commentReducer,
  credential: credentialReducer,
  event: eventsReducer,
  legalEntities: legalEntitiesReducer,
  project: projectReducer,
  rbac: rbacReducer,
  salaryHistory: salaryHistoryReducer,
  service: serviceReducer,
  task: taskReducer,
  user: userReducer,
  company: companyReducer,
  metaInformation: metaInformationReducer,
  schedule: scheduleReducer,
  workspace: workspaceReducer,
});

export default entitiesReducer;
